import type React from 'react';
import { shallowEqual } from 'react-redux';
import { useMemo } from 'react';
import type { UpsellProduct } from '../../Store/Upsell/state';
import styles from './UpsellSummary.module.scss';
import FormatPrice from '../../../general/Format/FormatPrice';
import Translation from '../../../general/Translation/Translation';
import { useTypedSelector } from '../../Store/connectors';

interface Props {
  productUpsells: UpsellProduct[];
}

const UpsellSummary: React.FC<Props> = ({ productUpsells }) => {
  const currency = useTypedSelector(
    ({ metaData }) => metaData.currency,
    shallowEqual,
  );
  const sumPrice = useMemo(
    () =>
      productUpsells.reduce(
        (carry, upsell) =>
          carry + upsell.price.numericValue * upsell.amountInCart,
        0,
      ),
    [productUpsells],
  );
  const amountOfItems = useMemo(
    () =>
      productUpsells.reduce((carry, upsell) => carry + upsell.amountInCart, 0),
    [productUpsells],
  );

  return (
    <div className={styles.UpsellSummary}>
      <h4 className={styles.UpsellSummary__heading}>
        <Translation
          pageString="upsell"
          stringId="upsells_heading"
        />
        <span>{amountOfItems ? ` (${amountOfItems})` : ''}</span>
        <div className={styles.UpsellSummary__heading__price}>
          {amountOfItems > 0 && (
            <FormatPrice price={{ currency, value: sumPrice }} />
          )}
        </div>
      </h4>
    </div>
  );
};

export default UpsellSummary;
